<template>
    <media-library-item
            class="media-library-folder"
            ref="newFolder"
            name=""
            v-bind:display-name="resource('MediaLibrary_CreateFolder_DisplayName')"
            v-bind:name-editor-placeholder="resource('MediaLibrary_CreateFolder_Placeholder')"
            v-on:item-clicked="startEdit"
            v-on:item-renamed="createFolder($event)"
            >
        <i class="fas fa-folder-plus fa-3x"></i>
    </media-library-item>
</template>

<script>
    import mediaApi from '../../../Api/media-library';

    import getResource from '../../../Util/resources';

    import {error as errorNotification } from "../Util/notifications";

    import MediaLibraryItem from './BaseMediaLibraryItem.vue';

    export default {
        name: "media-library-new-folder",
        components:{
            MediaLibraryItem
        },
        methods: {
            startEdit(){
                this.$refs.newFolder.isEditing = true
            },
            createFolder(name) {
                const vm = this;

                mediaApi.createFolder({
                    name: name,
                    parentId: vm.parentId
                }).then(((res) => {
                    vm.$emit('folder-created', res)
                }), errorNotification);
            },
            resource(name){
                return getResource(name);
            }
        },
        props: {
            mediaLibraryId: {
                type: String,
                required: true
            },
            parentId: {
                type: String,
                required: true
            }
        }
    };
</script>

<style scoped>

</style>
